import PropTypes from 'prop-types';
import { useMemo, useState, useEffect, useContext, createContext } from 'react';

import axios from 'src/utils/axios';

import { useAuthContext } from 'src/auth/hooks';

const DomainContext = createContext(undefined);

export const DomainProvider = ({ children }) => {
  const [domainData, setDomainData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();

  useEffect(() => {
    const fetchDomain = async () => {
      setIsLoading(true);
      const domain = window.location.host;
      const res = await axios.get(
        `/company/trader_domain?domain=${domain === 'localhost:3030' ? 'live.octolit.com' : domain}${user ? `client_id=${user?.id}` : ''}`
      );
      const setting = JSON.parse(res?.data?.trader_domain?.internal_brand?.theme_setting);
      let result = res?.data?.trader_domain;
      if (setting) {
        result = {
          ...result,
          colorPreset: setting?.color_preset,
          colorTheme: setting?.color_theme,
        };
      }
      setDomainData(result);
      setIsLoading(false);
    };

    fetchDomain();
  }, []);

  const value = useMemo(() => ({
    domainData,
    companyId: domainData?.company_id,
    isDomainLoading: isLoading
  }), [domainData, isLoading]);

  return (
    <DomainContext.Provider value={value}>
      {children}
    </DomainContext.Provider>
  );
};

DomainProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDomainContext = () => {
  const context = useContext(DomainContext);
  
  if (context === undefined) {
    throw new Error('useDomainInfo must be used within a DomainProvider');
  }
  
  return context;
}; 